import { render, staticRenderFns } from "./waterStandard.vue?vue&type=template&id=6a198338&"
import script from "./waterStandard.vue?vue&type=script&lang=js&"
export * from "./waterStandard.vue?vue&type=script&lang=js&"
import style0 from "./waterStandard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports